import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { APP_URL, SITE_URL } from "@/lib/config";

const linkCls = "text-sm text-muted-foreground transition-colors hover:text-foreground";

export default function Footer() {
  return (
    <footer className="no-print mt-20 border-t border-border bg-card">
      <div className="container grid gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-4 text-sm text-muted-foreground">
            শিক্ষকদের নিজের হাতে বানানো প্রশ্নপত্রের একটা খোলা ভাণ্ডার। খুঁজুন, দেখুন, কপি করে নিজের মতো করে নিন।
          </p>
        </div>

        <nav aria-label="গ্যালারি">
          <p className="mb-3 text-sm font-semibold text-foreground">গ্যালারি</p>
          <ul className="space-y-2">
            <li>
              <Link to="/papers" className={linkCls}>
                প্রশ্নপত্র খুঁজুন
              </Link>
            </li>
            <li>
              <Link to="/try" className={linkCls}>
                Live Try করুন
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="মুমতাহিন">
          <p className="mb-3 text-sm font-semibold text-foreground">মুমতাহিন</p>
          <ul className="space-y-2">
            <li>
              <a href={APP_URL} target="_blank" rel="noopener noreferrer" className={linkCls}>
                মূল অ্যাপ
              </a>
            </li>
            <li>
              <a href={SITE_URL} target="_blank" rel="noopener noreferrer" className={linkCls}>
                ওয়েবসাইট
              </a>
            </li>
            <li>
              <a href={`${SITE_URL}/bn/privacy`} target="_blank" rel="noopener noreferrer" className={linkCls}>
                প্রাইভেসি পলিসি
              </a>
            </li>
            <li>
              <a href={`${SITE_URL}/bn/terms`} target="_blank" rel="noopener noreferrer" className={linkCls}>
                শর্তাবলী
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-border">
        <div className="container py-5 text-xs text-muted-foreground">© মুমতাহিন — শিক্ষকদের জন্য, শিক্ষকদের হাতে তৈরি।</div>
      </div>
    </footer>
  );
}
